export default "__VITE_ASSET__CIyIsAbo__"